export default "__VITE_ASSET__34bf03b3__"